import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FilePondModule, registerPlugin } from 'ngx-filepond';

import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';

import { ServiceGridComponent } from '@teem/service-module/components/service-grid/service-grid.component';
import { EditServicesComponent } from '@teem/service-module/modals/edit-services/edit-services.component';
import { AddServicesComponent } from '@teem/service-module/modals/add-services/add-services.component';
import { StoreServicesRoutingModule } from '@teem/service-module/store-services-routing.module';
import { StoreServicesComponent } from '@teem/service-module/store-services.component';
import { ImportServiceModalComponent } from '@teem/service-module/modals/import-service-modal/import-service-modal.component';

// Import filepond plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';
// import { PinDropLocationComponent } from '@teem/store-module/modals/pin-drop-location/pin-drop-location.component';

registerPlugin(
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);

@NgModule({
  declarations: [
    StoreServicesComponent,
    ServiceGridComponent,
    AddServicesComponent,
    EditServicesComponent,
    ImportServiceModalComponent
  ],
  entryComponents: [
    AddServicesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    FilePondModule,
    SharedModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NgbModule,
    FilePondModule,
    StoreServicesRoutingModule,
  ]
})
export class StoreServicesModule { }
